import { Link as RouterLink } from 'react-router-dom';
import {
  node,
  oneOf,
  string,
} from 'prop-types';
import { Link as MuiLink } from '@material-ui/core';

function Link(props) {
  const componentProps = {};

  switch (props.variant) {
    default: {
      componentProps.component = RouterLink;
      componentProps.to = props.to;
      break;
    }

    case 'email': {
      componentProps.href = `mailto: ${props.to}`;
      break;
    }

    case 'external': {
      componentProps.href = props.to;
      componentProps.target = '_blank';
      break;
    }

    case 'telephone': {
      componentProps.href = `tel: ${props.to}`;
      break;
    }
  }

  return (<MuiLink
    style={props.styles}
    color={props.color}
    children={props.children}
    underline="none"
    {...componentProps}
  />);
}

Link.defaultProps = {
  variant: 'router',
  styles: null,
};

Link.propTypes = {
  children: node,
  color: oneOf(['primary', 'secondary']),
  to: string,
  styles: {},
  variant: oneOf([
    'email',
    'external',
    'function',
    'router',
    'telephone',
  ]),
};

export default Link;
